// extracted by mini-css-extract-plugin
export default {"topNav":"OG-z","category":"PG-z","noArrow":"QG-z","alternative":"RG-z","topLevelNavItem":"SG-z","navContainer":"TG-z","subcategoryHeading":"UG-z","subcategory":"VG-z"};